import {isPlainObject} from '@servicenow/ui-internal';
import log from '../log';

export function normalizeActionMeta(meta, {host}) {
	let normalizedMeta = meta;
	if (!isPlainObject(meta)) {
		normalizedMeta = {...meta};
		if (process.env.NODE_ENV !== 'production') {
			log(
				`While dispatching an action, Expected meta to be an Object but found ${meta}. This will result in inconsistent behavior when passing meta to an action handler`,
				{
					host,
					origin: 'normalizeActionMeta'
				}
			);
		}
	}

	return normalizedMeta;
}
